var _rect, _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEmailLogo = function SvgEmailLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.895996,
    width: 80,
    height: 79.2079,
    rx: 39.604,
    fill: "#EAEAF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0004 80.0008C74.628 80.0008 80.0008 74.628 80.0008 68.0004C80.0008 61.3728 74.628 56 68.0004 56C61.3728 56 56 61.3728 56 68.0004C56 74.628 61.3728 80.0008 68.0004 80.0008Z",
    fill: "#FDBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 61.4863H69.5L68.7424 70.6977H67.197L66.5 61.4863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0003 74.5142C68.7601 74.5142 69.3761 73.8983 69.3761 73.1385C69.3761 72.3786 68.7601 71.7627 68.0003 71.7627C67.2405 71.7627 66.6245 72.3786 66.6245 73.1385C66.6245 73.8983 67.2405 74.5142 68.0003 74.5142Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.3401V51.5001C20 53.0914 20.6321 54.6175 21.7574 55.7427C22.8826 56.8679 24.4087 57.5001 26 57.5001H56C57.5913 57.5001 59.1174 56.8679 60.2426 55.7427C61.3679 54.6175 62 53.0914 62 51.5001V34.3401L44.144 45.3261C43.1985 45.9078 42.1101 46.2158 41 46.2158C39.8899 46.2158 38.8015 45.9078 37.856 45.3261L20 34.3401Z",
    fill: "#9498B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30.816V30.5C62 28.9087 61.3679 27.3826 60.2426 26.2574C59.1174 25.1321 57.5913 24.5 56 24.5H26C24.4087 24.5 22.8826 25.1321 21.7574 26.2574C20.6321 27.3826 20 28.9087 20 30.5V30.816L39.428 42.772C39.9008 43.0629 40.4449 43.2168 41 43.2168C41.5551 43.2168 42.0992 43.0629 42.572 42.772L62 30.816Z",
    fill: "#9498B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(56 56)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emailLogo.bd29746b6942c6ffea1aa8d7ba36422f.svg";